import React from 'react';
// Components
import SetupDeals from 'components/common/SetupDeals/SetupDeals';

const SetupAthleteDeals: React.FC = () => {
  return <SetupDeals />;
};

export default SetupAthleteDeals;
